/**
 * A feature set is a collection of features. It contains methods to
 * query the collection.
 *
 * Features are unique by id, so this set can't contain multiple instances of
 * Feature sharing the same id, even though they are not the same object.
 *
 * @param {Feature[]} features - List of Feature instances
 */
export default class FeatureSet {
	constructor({ features = [] } = {}) {
		this._features = {};
		for (const feature of features) {
			this._features[feature.getId()] = feature;
		}
	}

	hasId(id) {
		return !!this._features[id];
	}

	getById(id) {
		return this._features[id];
	}

	addFeature(feature) {
		const id = feature.getId();
		if (this.hasId(id)) return;
		this._features[id] = feature;
	}

	addFeatures(features) {
		for (const feature of features) {
			this.addFeature(feature);
		}
	}

	append(anotherFeatureSet) {
		for (const feature of anotherFeatureSet) {
			this.addFeature(feature);
		}

		return this;
	}

	removeFeature(feature) {
		const id = feature.getId();
		delete this._features[id];
	}

	getNumberOfFeatures() {
		return Object.keys(this._features).length;
	}

	[Symbol.iterator]() {
		return Object.values(this._features)[Symbol.iterator]();
	}
}
